import { LayoutInstruction } from './shared';
export class LayoutPanelInstruction extends LayoutInstruction {
  getDefaults() {
    return {
      title: null,
      toggleable: false
    };
  }
  constructor(config) {
    super();
    /** object map of input name -> source name / function */
    this.inputMap = {
      title: 'title',
      toggleable: 'toggleable',
      collapsed: 'toggleable'
    };
    this.attributeMap = {};
    this.setConfig(config);
  }
  load() {
    // eslint-disable-next-line @nx/enforce-module-boundaries
    return import(/* webpackChunkName: "forms-layout-panel" */
    /* webpackMode: "lazy" */
    '@common/forms/frontend-shared/layout-instruction-components/panel').then(m => m.InstructionLayoutPanelComponent);
  }
}